const getDefaultState = () => ({
  selectedBookingRef: undefined,
  booking: {
    itemLoading: false,
    itemError: undefined,
    id: undefined,
    bookingRef: undefined,
    currency: undefined,
    customer: {
      id: undefined,
      type: undefined,
      firstName: undefined,
      lastName: undefined,
      phone: undefined,
      email: undefined,
    },
    stays: [],
  },
  participants: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  areas: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/booking/defaultState.js